import React, { ReactElement } from 'react';

import { IShopifyApp } from '../../shared/types/IShopifyAppData';
import { FooterTestIds } from '../FooterTestIds';

export function AccreditedBusiness (): ReactElement {
    const shopify: IShopifyApp = window.ozShopifyApp;

    return (
        <img
            className="h-8"
            src={shopify.assets.accreditedBusinessUrl}
            data-testid={FooterTestIds.ACCREDITED_BUSINESS_IMG}
            alt="AccreditedBusiness"
        />
    );
}
